import { LdsModal, LdsButton } from "@elilillyco/ux-lds-react";
import "./../../assets/scss/details/deleteSpecModal.scss";
const EditUserStatus = ({
  isEditStatusOpen,
  setisEditStatusOpen,
  userStatusVal,
  updateUserStatus,
}) => {
  return (
    <>
      <LdsModal
        modalId="edit-user-status-modal"
        className="text-center"
        open={isEditStatusOpen}
        setModalOpen={setisEditStatusOpen}
      >
        <div>
          <h2>
            Are you sure you want to{" "}
            {userStatusVal ? "Deactivate " : "Activate "}
            user.
          </h2>
        </div>
        <div className="savecl">
          <LdsButton
            iconPosition="before"
            className="button-icon-left blue-bdr-btn test"
            onClick={() => {
              setisEditStatusOpen(false);
              updateUserStatus(false);
            }}
          >
            No
          </LdsButton>
          <LdsButton
            iconPosition="before"
            className="button-icon-left  blue-btn ml-2"
            onClick={() => {
              setisEditStatusOpen(false);
              updateUserStatus(true);
            }}
          >
            Confirm Yes
          </LdsButton>
        </div>
      </LdsModal>
    </>
  );
};
export default EditUserStatus;
